import type { NotifyPort } from '@/features/messages/domain/notify'
import type { CreateWorkItemInput, WorkItem, WorkItemPort } from '../domain/workflow'

const createWorkItem = async (
	port: WorkItemPort,
	input: CreateWorkItemInput,
	notify: NotifyPort,
): Promise<WorkItem | null> => {
	try {
		const created = await port.create(input)
		notify.success('workItem.created')
		return created
	} catch {
		notify.error('workItem.createFailed')
		return null
	}
}

export { createWorkItem }
